import * as React from 'react';
import { SurveyNoteHeaderContainer } from '../../components/notes/SurveyNoteHeaderContainer';
import ManageSurveyDimensions from '../../components/pages/manage-survey-dimensions/ManageSurveyDimensions';
import ContentConstants from '../../contentConstants';
import { SurveyStep } from '../../models';
import { PreviousStepButton, SaveAndNextButton, SaveButton, SaveButtonsGroup } from '../save-buttons/SaveButtonsGroup';
import { SurveyPageStateSetter } from '../state-setter/SurveyPageStateSetter';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';

export class ManageSurveyDimensionsPage extends React.PureComponent<PageStateSetterRouteProps> {
	public render() {
		return (
			<>
				<ManageSurveyDimensions
					pageTitle={ContentConstants.TITLE_DEFINE_SURVEY_CONTENT}
					additionalHeaderContent={<SurveyNoteHeaderContainer />}
					footerContent={
						<SaveButtonsGroup>
							<PreviousStepButton />
							<SaveButton />
							<SaveAndNextButton />
						</SaveButtonsGroup>
					}
				/>
				<SurveyPageStateSetter {...this.props} currentStep={SurveyStep.ManageDimensions} />
			</>
		);
	}
}
